// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/user-profile/app/css/app.css
// module id = 781
// module chunks = 0